import { useEffect, useState } from "react";
import { createMessageTemplateHeaderImageDownloadUrl } from "../../api/inbox-api.js";
import {
  readCachedTemplateHeaderImageUrl,
  writeCachedTemplateHeaderImageUrl,
} from "./template-header-image-url-cache.js";

export function useTemplateHeaderImageUrl(input: {
  organizationId: number;
  conversationId: number;
  messageId: string;
  enabled: boolean;
}): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!input.enabled) {
      setUrl(null);
      return;
    }

    const cached = readCachedTemplateHeaderImageUrl(input.organizationId, input.messageId);
    if (cached) {
      setUrl(cached.url);
      return;
    }

    const controller = new AbortController();
    void createMessageTemplateHeaderImageDownloadUrl(
      input.organizationId,
      input.conversationId,
      input.messageId,
      controller.signal,
    )
      .then((response) => {
        if (controller.signal.aborted) return;
        writeCachedTemplateHeaderImageUrl(
          input.organizationId,
          input.messageId,
          response.url,
          response.expiresAt,
        );
        setUrl(response.url);
      })
      .catch(() => {
        if (!controller.signal.aborted) setUrl(null);
      });

    return () => controller.abort();
  }, [input.enabled, input.organizationId, input.conversationId, input.messageId]);

  return url;
}
